module.exports = __webpack_public_path__ + "img/GAME_BUNGEOPPANG.0c359bc3.png";